import React from 'react';
import PropTypes from 'prop-types';

import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import _ from 'underscore';

import {
  CHANNEL_ALL_RECOMMENDATIONS,
  CHANNEL_TYPES,
  FAC_RECOMENDATIONTYPE_FEATUREID_MAPPING,
} from '../consts';

export const withCoupon = (WrappedComponent) => {
  class HoC extends React.Component {
    static displayName = `withCoupon(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      defaultOptions: PropTypes.objectOf(PropTypes.any),
      dataService: PropTypes.shape({
        getSummary: PropTypes.func.isRequired,
      }).isRequired,
      data: PropTypes.shape(_.reduce(
        CHANNEL_ALL_RECOMMENDATIONS[CHANNEL_TYPES.RECOMMENDATION],
        recommendation => ({
          [recommendation]: PropTypes.object,
        }),
        {}
      )),
    };

    static defaultProps = {
      defaultOptions: {},
      data: {},
    };

    state = {
      rawCouponData: null,
    };

    componentDidMount = () => {
      if (_.isNull(this.state.rawCouponData)
        && _.any(
          this.props.data,
          rec => _.has(FAC_RECOMENDATIONTYPE_FEATUREID_MAPPING, rec.type)
        )) {
        this.reload();
      }
    };

    componentWillUnmount = () => {
      this.cancel();
    };

    reload = () => {
      this.cancel();

      const {
        defaultOptions,
        dataService,
      } = this.props;

      this.loadToken = createAsyncToken(dataService
        .getCoupon(defaultOptions))
        .on({
          onSuccess: (rawCouponData) => {
            this.setState({
              rawCouponData,
            });
          },
        });
    };

    cancel = () => {
      if (this.loadToken) {
        this.loadToken.cancel();
      }
    };

    render = () => (<WrappedComponent
      {...this.props}
      rawCouponData={this.state.rawCouponData}
    />);
  }

  return hoistNonReactStatics(HoC, WrappedComponent);
};
